import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoadingPage.css';

function LoadingPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/Home');
        }, 4000); //4 seconds
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="LoadingPage">
            <h1 className="LoadingPage-Title">Here4U</h1>
            <h2 className="LoadingPage-Text">Helping</h2>
            <h2 className="LoadingPage-Text">You</h2>
            <h2 className="LoadingPage-Text">Make</h2>
            <h2 className="LoadingPage-Text">Informed</h2>
            <h2 className="LoadingPage-Text">Choices,</h2>
            <h2 className="LoadingPage-Text">Now</h2>
            <div className="ellipsis-loader">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
        </div>
    );
}

export default LoadingPage;